import React from 'react';

// ui-components
import {Text} from '@shopify/polaris';

const Home: React.FC<React.PropsWithoutRef<any>> = () => (
  <div style={{marginTop: 150}}>
    <Text variant="heading3xl" as="h2" alignment="center" tone="magic">
      Welcome to <strong>OpenLetterConnect</strong>
    </Text>
  </div>
);

export default Home;
